export default {
  creditBalance: {
    en: 'Credit (Balance {balance})',
  },
}
